import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import * as actions from '../../../../../reducers/Service/actions';
import { EditTextArea } from '../PickupDelivery/components';
import {
  Container,
  Title,
  Text,
  Info,
} from './style';

export class AgentInstructions extends Component {
  onAgentInstructionsChange = (value) => {
    const {
      id,
      updateService,
    } = this.props;

    updateService({ agentInstructions: value, serviceId: id });
  };

  render() {
    const {
      agentInstructions,
    } = this.props;

    return (
      <Container>
        <Title>Additional instructions</Title>
        <Text>
          <EditTextArea onChange={this.onAgentInstructionsChange} value={agentInstructions}>
            {agentInstructions || <Info>Write here any additional information that the trustporter should know</Info>}
          </EditTextArea>
        </Text>
      </Container>
    );
  }
}

AgentInstructions.propTypes = {
  agentInstructions: PropTypes.string,
  id               : PropTypes.string,
  updateService    : PropTypes.func,
};

AgentInstructions.defaultProps = {
  agentInstructions: '',
  id               : '',
  updateService    : () => {},
};

const mapStateToProps = ({
  service: { data: { _id: id, agentInstructions } },
}) => ({
  id,
  agentInstructions,
});

const mapDispatchToProps = dispatch => ({
  updateService: data => dispatch(actions.updateService(data)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AgentInstructions);
